// extracted by mini-css-extract-plugin
module.exports = {"actions":"CountControl_actions__2qf62","actionButton":"CountControl_actionButton__2GV7s","countDisplay":"CountControl_countDisplay__3Lg6h","button":"CountControl_button__1xCb9"};